module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-play-box tv-video"
  }, [_c('div', {
    staticClass: "jin-play-box__h"
  }, [_c('div', {
    staticClass: "jin-play-box__l"
  }, [_c('live-staus-tag', {
    attrs: {
      "preview": _vm.hasPreviewVideo,
      "repeat": _vm.isPlayingRepeat,
      "live": _vm.isLive
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "jin-play-box__title"
  }, [_vm._v(_vm._s(_vm.customTitle || _vm.title))])], 1), _vm._v(" "), _c('div', {
    staticClass: "jin-play-box__r"
  }, [_c('el-popover', {
    ref: "phoneSharePopover",
    attrs: {
      "trigger": "hover",
      "placement": "bottom-end",
      "popper-class": "glass-popover glass-effect is-black",
      "visible-arrow": false
    },
    on: {
      "show": function($event) {
        return _vm.onPopoverShow('phoneSharePopover')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "16px"
    }
  }, [(_vm.liveType === 'tradingNew') ? _c('img', {
    staticStyle: {
      "border-radius": "4px"
    },
    attrs: {
      "width": "120",
      "src": require("../../../assets/img/trading_qrcode.png")
    }
  }) : _c('img', {
    staticStyle: {
      "border-radius": "4px"
    },
    attrs: {
      "width": "120",
      "src": require("../../../assets/img/tv_qrcode.png")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px",
      "text-align": "center",
      "font-size": "14px",
      "font-weight": "bold",
      "color": "var(--on-surface)",
      "user-select": "none"
    }
  }, [_c('div', {
    staticStyle: {
      "line-height": "normal"
    }
  }, [_vm._v("\n              扫描右侧二维码\n              "), _c('br'), _vm._v("\n              畅享手机看直播\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "jin-play-box__btn jin-play-box__phone",
    staticStyle: {
      "color": "var(--on-surface)"
    },
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('PhoneSvg', {
    attrs: {
      "size": 32
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tv-video__b"
  }, [((_vm.isTrySee || (_vm.isRepeatTrySee && _vm.isPlayingRepeat))) ? [(_vm.isLive ? !_vm.isTrySeeEnd : !_vm.isRepeatTrySeeEnd) ? [(_vm.isMobile) ? [_c('div', {
    staticClass: "try-free-tips",
    class: {
      'svip-only': _vm.liveRoleType === _vm.LIVE_ROLE_TYPE.svip || _vm.repeatRoleType === _vm.LIVE_ROLE_TYPE.svip,
      'vip-only': _vm.liveRoleType === _vm.LIVE_ROLE_TYPE.vip || _vm.repeatRoleType === _vm.LIVE_ROLE_TYPE.vip,
    },
    on: {
      "click": _vm.toVipPage
    }
  }, [_vm._v("\n            此为试看版，"), _c('span', [_vm._v("购买")]), _c('div', {
    staticClass: "logo"
  }), _vm._v(" 观看完整版\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "try-free-top",
    class: {
      'svip': _vm.liveRoleType === _vm.LIVE_ROLE_TYPE.svip || _vm.repeatRoleType === _vm.LIVE_ROLE_TYPE.svip,
      'vip': _vm.liveRoleType === _vm.LIVE_ROLE_TYPE.vip || _vm.repeatRoleType === _vm.LIVE_ROLE_TYPE.vip,
      'is-mobile': _vm.isMobile
    },
    on: {
      "click": _vm.toVipPage
    }
  })] : _vm._e()] : [_c('div', {
    staticClass: "try-see-end"
  }, [_c('p', [_vm._v("该" + _vm._s(_vm.isLive ? '直播' : '视频') + "为VIP" + _vm._s(_vm.isLive ? '直播' : '重播') + "，试看已结束")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.toVipPage
    }
  }, [_vm._v("立即成为VIP")])])]] : _vm._e(), _vm._v(" "), (!_vm.repeatImageUrl) ? [(_vm.liveUrl) ? [(_vm.liveUrl) ? [(_vm.isMobile) ? _c('div', {
    staticClass: "tv-video__box"
  }, [_c('video', {
    attrs: {
      "id": "J_tv_video",
      "width": "100%",
      "height": "100%",
      "controls": "controls",
      "webkit-playsinline": "",
      "playsinline": "",
      "x-webkit-airplay": "allow",
      "x5-playsinline": "",
      "autoplay": "autoplay"
    }
  })]) : _c('div', {
    staticClass: "tv-video__box",
    attrs: {
      "id": "J_tv_box"
    }
  })] : _c('img', {
    staticClass: "tv-video__poster live",
    attrs: {
      "src": _vm.poster
    }
  })] : (_vm.hasPreviewVideo) ? _c('div', [(_vm.isMobile) ? _c('div', {
    staticClass: "tv-video__box"
  }, [_c('video', {
    attrs: {
      "id": "J_tv_video",
      "width": "100%",
      "height": "100%",
      "controls": "controls",
      "webkit-playsinline": "",
      "playsinline": "",
      "x-webkit-airplay": "allow",
      "x5-playsinline": "",
      "autoplay": "autoplay"
    }
  })]) : _c('div', {
    staticClass: "tv-video__box preview",
    attrs: {
      "id": "J_tv_box"
    }
  })]) : _c('div', {
    staticClass: "tv-video__poster preview",
    class: {
      trading: _vm.isTradingPageAndNotAVip
    },
    on: {
      "click": function () {
        _vm.isTradingPageAndNotAVip && _vm.toVipPage()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.posterUrl
    }
  })])] : _c('div', {
    staticClass: "tv-video__poster repeat",
    class: {
      trading: _vm.isTradingPageAndNotAVip
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.repeatImageUrl
    }
  }), _vm._v(" "), (_vm.repeatImageUrl && _vm.isTradingPageAndNotAVip) ? _c('a', {
    staticClass: "tv-video__vip-link",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.toVipPage
    }
  }) : _vm._e(), _vm._v(" "), _c('glass-btn', {
    attrs: {
      "round": "",
      "type": "default"
    },
    on: {
      "click": _vm.showRepeat
    }
  }, [_c('PlayLineSvg'), _vm._v(" "), _c('span', [_vm._v("点击这里收看最近一期节目")])], 1)], 1), _vm._v(" "), (_vm.isShowNextTV && false) ? _c('div', {
    staticClass: "tv-video__mask"
  }, [_c('div', {
    staticClass: "tv-video-tips"
  }, [_c('h4', {
    staticClass: "tv-video-tips__h"
  }, [_vm._v("\n          温馨提示：" + _vm._s(_vm.nowDatas.prevue.title) + "即将直播\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "tv-video-tips__b"
  }, [_c('jin-button', {
    on: {
      "click": _vm.closeNextTV
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('jin-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showNextTV
    }
  }, [_vm._v("提前进入")])], 1)])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tv-video__f"
  }, [_c('div', {
    staticClass: "tv-video__l"
  }, [_c('div', {
    staticClass: "tv-video-info"
  }, [(_vm.getEmceeInfo('pic')) ? _c('img', {
    staticClass: "tv-video-info__avatar",
    attrs: {
      "src": _vm.getEmceeInfo('pic'),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getEmceeInfo('nick')) ? _c('span', {
    staticClass: "tv-video-info__text"
  }, [_vm._v(_vm._s(_vm.getEmceeInfo('nick')))]) : _vm._e(), _vm._v(" "), (_vm.wechatUrl) ? _c('el-popover', {
    ref: "weixinFollowPopover",
    attrs: {
      "trigger": "hover",
      "placement": "top",
      "popper-class": "glass-popover glass-effect is-black",
      "visible-arrow": false
    },
    on: {
      "show": function($event) {
        return _vm.onPopoverShow('weixinFollowPopover')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('img', {
    staticStyle: {
      "border-radius": "4px"
    },
    attrs: {
      "width": "120",
      "src": _vm.wechatUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px",
      "text-align": "center",
      "font-size": "14px",
      "font-weight": "bold",
      "color": "var(--on-surface)",
      "user-select": "none"
    }
  }, [_vm._v("微信扫一扫关注")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "glass",
      rawName: "v-glass",
      value: ({
        type: 'btnNormal'
      }),
      expression: "{type: 'btnNormal'}"
    }],
    staticClass: "tv-video-info__btn",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('WeixinSvg')], 1)]) : _vm._e(), _vm._v(" "), (_vm.getEmceeInfo('weibo')) ? _c('a', {
    directives: [{
      name: "glass",
      rawName: "v-glass",
      value: ({
        type: 'btnNormal'
      }),
      expression: "{type: 'btnNormal'}"
    }],
    staticClass: "tv-video-info__btn is-weibo",
    attrs: {
      "target": "_blank",
      "href": _vm.getEmceeInfo('weibo')
    }
  }, [_c('WeiboSvg')], 1) : _vm._e(), _vm._v(" "), (_vm.wechatUrl || _vm.getEmceeInfo('weibo')) ? _c('base-divider') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "glass",
      rawName: "v-glass",
      value: ({
        type: 'btnNormal'
      }),
      expression: "{ type: 'btnNormal' }"
    }],
    staticClass: "tv-video-info__attention",
    class: {
      'is-follow': _vm.follow
    },
    on: {
      "click": _vm.onAttend
    }
  }, [(!_vm.follow) ? _c('PlusSvg') : _vm._e(), _vm._v("\n          " + _vm._s(_vm.follow ? '已关注' : '关注') + "\n        ")], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tv-video-share"
  }, [_c('div', {
    staticClass: "tv-video-share__label"
  }, [_c('ShareSvg'), _vm._v("\n        分享：\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "tv-video-share__btn-group"
  }, [_c('a', {
    staticClass: "tv-video-share__btn",
    attrs: {
      "target": "_blank",
      "href": "https://connect.qq.com/widget/shareqq/index.html?url=https%3A%2F%2Ftv.jin10.com%2F%23%2F&title=%E9%87%91%E5%8D%81TV%E7%9B%B4%E6%92%AD%20-%20%E9%87%91%E5%8D%81%E6%95%B0%E6%8D%AE&source=%E9%87%91%E5%8D%81TV%E7%9B%B4%E6%92%AD%20-%20%E9%87%91%E5%8D%81%E6%95%B0%E6%8D%AE&desc=%E9%87%91%E5%8D%81TV%E6%89%BF%E8%BD%BD%E7%9B%B4%E6%92%AD%E8%8A%82%E7%9B%AE%EF%BC%8C%E5%AE%9E%E6%97%B6%E7%95%99%E8%A8%80%E4%BA%92%E5%8A%A8%E3%80%82%E5%9C%A8TV%E9%A1%B5%E9%9D%A2%E6%82%A8%E5%B0%86%E7%AC%AC%E4%B8%80%E6%97%B6%E9%97%B4%E8%A7%82%E7%9C%8B%E5%88%B0%E9%87%91%E5%8D%81%E6%97%A9%E7%9F%A5%E9%81%93%E3%80%81%E7%8E%AF%E7%90%83%E8%BE%9B%E8%AF%B4%E3%80%81%E9%87%91%E5%8D%81%E5%90%8C%E4%BC%A0%E5%A3%B0%E8%AF%91%E7%AD%89%E8%8A%82%E7%9B%AE%E7%9B%B4%E6%92%AD%EF%BC%8C%E9%94%81%E5%AE%9A%E8%8A%82%E7%9B%AE%E7%9B%B4%E6%92%AD%E9%A2%84%E5%91%8A%EF%BC%8C%E8%8E%B7%E5%8F%96%E5%B9%B2%E8%B4%A7%E5%88%86%E7%A7%92%E5%BF%85%E4%BA%89%E3%80%82&pics=https%3A%2F%2Fimages.jin10.com%2Favatar%2F8dfe8fb5-01ff-48c2-a824-2f43677d9548.png%2Flite"
    }
  }, [_c('QqSvg')], 1), _vm._v(" "), _c('a', {
    staticClass: "tv-video-share__btn",
    attrs: {
      "target": "_blank",
      "href": "http://service.weibo.com/share/share.php?url=https%3A%2F%2Ftv.jin10.com%2F%23%2F&title=%E9%87%91%E5%8D%81TV%E7%9B%B4%E6%92%AD%20-%20%E9%87%91%E5%8D%81%E6%95%B0%E6%8D%AE&pic=https%3A%2F%2Fimages.jin10.com%2Favatar%2F8dfe8fb5-01ff-48c2-a824-2f43677d9548.png%2Flite&appkey="
    }
  }, [_c('WeiboSlimSvg', {
    attrs: {
      "size": 24
    }
  })], 1), _vm._v(" "), _c('el-popover', {
    ref: "weixinSharePopover",
    attrs: {
      "trigger": "hover",
      "placement": "top",
      "popper-class": "glass-popover glass-effect is-black",
      "visible-arrow": false
    },
    on: {
      "show": function($event) {
        return _vm.onPopoverShow('weixinSharePopover')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('WexinShareQrcode'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px",
      "text-align": "center",
      "font-size": "14px",
      "font-weight": "bold",
      "color": "var(--on-surface)",
      "user-select": "none"
    }
  }, [_vm._v("微信扫一扫分享")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tv-video-share__btn",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('WeixinSlimSvg', {
    attrs: {
      "size": 24
    }
  })], 1)])], 1)])]), _vm._v(" "), _c('vip-dialog', {
    model: {
      value: (_vm.showVipDialog),
      callback: function($$v) {
        _vm.showVipDialog = $$v
      },
      expression: "showVipDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-760d7c20","hasScoped":true,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tv/modules/Content/src/video.vue
// module id = Ja+B
// module chunks = 2 3 4 6 7 8 9